import React from 'react'
// import { Formik, Form, Field, ErrorMessage } from 'formik'
import { StrategyType, ReportRequestData } from './common'

interface ReportRequestProps {
  onStart?: (data: ReportRequestData) => Promise<void>
}

export class ReportRequest extends React.Component<ReportRequestProps, ReportRequestData> {
  constructor(props: ReportRequestProps) {
    super(props)

    const data = new ReportRequestData()
    data.url = window.localStorage.getItem('lastUrl') || ''
    data.strategy = (window.localStorage.getItem('lastStrategy') || 'mobile') as StrategyType
    this.state = data

    this.handleUrlChanged = this.handleUrlChanged.bind(this)
    this.handleStrategyChanged = this.handleStrategyChanged.bind(this)
    this.start = this.start.bind(this)
  }

  handleUrlChanged(e: React.ChangeEvent<HTMLInputElement>) {
    window.localStorage.setItem('lastUrl', e.target.value)
    this.setState({ url: e.target.value })
  }

  handleStrategyChanged(e: React.ChangeEvent<HTMLInputElement>) {
    window.localStorage.setItem('lastStrategy', e.target.value)
    this.setState({ strategy: e.target.value as StrategyType })
  }

  async start() {
    if (this.props.onStart) await this.props.onStart(this.state)
  }

  public render() {
    return (
      <div>
        <div className="form-group">
          <label htmlFor="">対象ページのURLを入力</label>
          <input type="text" className="form-control" value={this.state.url} onChange={this.handleUrlChanged} placeholder="例: https://www.ideamans.com/" />
        </div>
        <div className="row">
          <div className="col-6">
            <div className="form-group">
              <label htmlFor="">対象のデバイスを選択</label>
              <div>
                <div className="form-check form-check-inline">
                  <input type="radio" className="form-check-input" name="strategy" id="report-request-strategy-mobile" value="mobile" checked={this.state.strategy === 'mobile'} onChange={this.handleStrategyChanged} />
                  <label className="form-check-label" htmlFor="report-request-strategy-mobile">モバイル</label>
                </div>
                <div className="form-check form-check-inline">
                  <input type="radio" className="form-check-input" name="strategy" id="report-request-strategy-desktop" value="desktop" checked={this.state.strategy === 'desktop'} onChange={this.handleStrategyChanged} />
                  <label className="form-check-label" htmlFor="report-request-strategy-desktop">PC(デスクトップ)</label>
                </div>
              </div>
            </div>

          </div>
          <div className="col-6">
            <div className="mt-2">
              <button type="button" className="btn btn-primary btn-lg btn-block" onClick={this.start}>→ PageSpeed Insights 試験対策レポートを作成</button>
            </div>
          </div>
          {/* <div className="form-group">
              <label htmlFor="">メールアドレス</label>
              <input type="text" className="form-control" value={this.props.reportRequest.email} onChange={this.handleEmailChanged} />
              <p className="form-text text-muted">
                弊社サービスについて案内させていただきます。気に入らなければすぐ購読解除いただいて結構です。
                </p>
              <p className="form-text text-danger">
                メールアドレスの入力に承諾できない場合は本サービスのご利用をお控えください。
              </p>
            </div> */}
        </div>
      </div>
    )
  }
}
